/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="59.54" height="95.46" viewBox="0 0 59.54 95.46" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <path d="M77.27,29.5A29.77,29.77,0,1,0,107,59.27,29.77,29.77,0,0,0,77.27,29.5Zm0,2.5A27.27,27.27,0,1,1,50,59.27,27.27,27.27,0,0,1,77.27,32Z" transform="translate(-47.5 -29.5)" fill="#0e497b"/><polygon points="42.06 18.93 44.19 21.05 27.09 38.15 16.35 27.42 18.47 25.29 27.09 33.91 42.06 18.93" fill="#ffb81c"/><path d="M96.16,80a1.24,1.24,0,0,1,1.29,1.07v.13l1.7,42.48a1.25,1.25,0,0,1-1.82,1.16l-.1-.06-20-12.8-20,12.8a1.26,1.26,0,0,1-1.93-1v-.12l1.7-42.48a1.25,1.25,0,0,1,2.5,0v.13L58,121.36l18.62-11.93a1.26,1.26,0,0,1,1.23-.07l.12.07,18.63,11.93L95,81.28A1.24,1.24,0,0,1,96,80Z" transform="translate(-47.5 -29.5)" fill="#0e497b"/>
</svg>

    );
  }
}

Icon.displayName = 'RibbonWithCheckmarkIcon';

export default Icon;
